import { ID } from "../core/id";

export enum DiscontStatus {
  WAIT = "wait", // Ожидает применения
  OK = "ok", // Применён
  CLOSE = "close", // Использован
  DEDLINE = "dedline", // Не Использован
}

export enum DiscontType {
  MASS = "mass", // Рассылка
  TELEGRAM = "telegram", // Телеграм
  FIRST = "first", // Первый заказ
  TWO = "two", // Второй заказ
  SUPPORT = "support", // Поддержка
  FEEDBACK = "feedback", // Обратная связь
  SHARE = "share", // Поделился
}

export interface Discont {
  id: ID;
  user_id: ID | null;
  percent: number;
  start_sum: number;
  status: DiscontStatus;
  type: DiscontType;
  date_close: number;
  date_modified: number;
  date_published: number;
}
